class ProductOptionPopup {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.trigger = wrapper.querySelector('.product-options__trigger');
    this.overlay = wrapper.querySelector('.product-options__overlayPanel');
    this.valueEl = wrapper.querySelector('[data-option-value]');
    this.inputs = wrapper.querySelectorAll('input[type="radio"]');

    this.bindEvents();
  }

  bindEvents() {
    // Toggle overlay
    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggle();
    });

    // Keyboard accessibility (Enter / Space)
    this.trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      }
    });

    // Option change
    this.inputs.forEach(input => {
      input.addEventListener('change', () => {
        this.updateValue(input.value);
        this.close();
      });
    });

    // Outside click
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.close();
      }
    });
  }

  toggle() {
    if(this.wrapper.classList.contains('open'))
        this.close();
    else
      this.open();
  }

  open() {
    document.querySelectorAll('.product-options__wrapper.open')
    .forEach(w => w.classList.remove('open'));

    this.wrapper.classList.add('open');
  }

  close() {
    this.wrapper.classList.remove('open');
  }

  updateValue(value) {
    if (this.valueEl) {
      this.valueEl.textContent = value;
    }
  }
}

document.querySelectorAll('.product-options__wrapper[data-has-popup="true"]').forEach(wrapper => {
  new ProductOptionPopup(wrapper);
});